import { Button, Modal } from '@hakimo-ui/shared/ui-base';

interface Props {
  onCloseCb: () => void;
  open: boolean;
  reconnect: () => void;
  title: string;
}

export function DuplicateSessionModal(props: Props) {
  const { onCloseCb, open, reconnect, title } = props;
  const actions = (
    <>
      <Button variant="primary" onClick={reconnect}>
        Use here
      </Button>
      <Button onClick={onCloseCb}>Cancel</Button>
    </>
  );
  return (
    <Modal
      open={open}
      onClose={onCloseCb}
      title="Duplicate Session"
      footer={actions}
    >
      <div className="p-6">
        {title} is open in another window. Click "Use here" to use {title} in
        this window.
      </div>
    </Modal>
  );
}
